export let EmbedVersion;
(function (EmbedVersion) {
  EmbedVersion["NEXT"] = "NEXT";
  EmbedVersion["V2_PRERELEASE"] = "V2_PRERELEASE";
  EmbedVersion["V2"] = "V2";
  EmbedVersion["V3"] = "V3";
})(EmbedVersion || (EmbedVersion = {}));